import React, { useState, useEffect } from "react";
import Logo from "../../assets/images/survey/logo.svg";
import Bike from "../../assets/images/survey/bike.svg";
import restService from "../../restService";
import { ModalComponent } from "../components";
import WHATSAPP from "../../assets/images/survey/whatsapp.svg";
import FACEBOOK from "../../assets/images/survey/facebook.svg";
import TWITTER from "../../assets/images/survey/twitter.svg";
import {
  TwitterShareButton,
  FacebookShareButton,
  WhatsappShareButton,
} from "react-share";

const campaignID_ = "62834ed429b3cbe224437a3e"; //--> prod
// const campaignID_ = "62716fbcba13726d1a3f9d07"; //--> sandbox

const Survey = () => {
  const [surveyData, setSurveyData] = useState({
    ageGroup: "",
    region: "",
    skus: [],
    flavours: [],
    gender: "",
  });

  const [loading, setLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [flavors, setFlavors] = useState([
    { name: "Chocolate", isChecked: false },
    { name: "Strawberry", isChecked: false },
    { name: "Vanilla", isChecked: false },
    { name: "Double Treat", isChecked: false },
  ]);

  const [sku, setSku] = useState([
    { name: "250ml", isChecked: false },
    { name: "500ml", isChecked: false },
    { name: "1L", isChecked: false },
    { name: "2L", isChecked: false },
  ]);

  const handleChange = (e) => {
    setSurveyData({
      ...surveyData,
      [e.target.name]: e.target.value,
    });
  };

  const ageGroup = [
    "18 - 24yrs",
    "25 - 34yrs",
    "35 - 44yrs",
    "45 - 54yrs",
    "55 - 64yrs",
    "65+",
  ];

  const regions = [
    "Northern Region",
    "Western Region",
    "Volta Region",
    "Eastern Region",
    "Upper East Region",
    "Upper West Region",
    "Ashanti Region",
    "Central Region",
    "Greater Accra Region",
    "North-East Region",
    "Oti Region",
    "Ahafo Region",
    "Bono Region",
    "Western North Region",
    "Savannah Region",
    "Bono East Region",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOpenModal(true);

    try {
      await restService.Survey.submitSurvey(campaignID_, surveyData);

      setSurveyData({
        ageGroup: "",
        region: "",
        skus: [],
        flavours: [],
        gender: "",
      });

      setSku([
        { name: "250ml", isChecked: false },
        { name: "500ml", isChecked: false },
        { name: "1L", isChecked: false },
        { name: "2L", isChecked: false },
      ]);

      setFlavors([
        { name: "Chocolate", isChecked: false },
        { name: "Strawberry", isChecked: false },
        { name: "Vanilla", isChecked: false },
        { name: "Double Treat", isChecked: false },
      ]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    if (!hasVisited()) {
      handleVisitCount();
      setVisited();
    }
  }, []);

  const hasVisited = () => {
    const visited = window.localStorage.getItem("visitedUser");
    return visited;
  };

  const setVisited = () => {
    window.localStorage.setItem("visitedUser", "true");
  };

  const handleVisitCount = async () => {
    try {
      await restService.Survey.visitCount(campaignID_);
    } catch (error) {
      console.log(error);
    }
  };

  const handleShareCount = async (channel) => {
    try {
      await restService.Survey.shareCount(campaignID_, channel);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col gap-3 justify-center items-center">
      <div className="mt-6">
        <img src={Logo} alt="" />
      </div>

      <div className="px-10 lg:w-[30%]">
        <p className="text-[#194179]  font-[600] text-lg text-center">
          Thank you for participating in the Y33kor Dubai Promo!
        </p>
      </div>

      <form className="px-7 flex flex-col lg:w-[30%] justify-start items-start w-full gap-5 mt-3">
        {/* gender */}
        <div className="flex flex-col w-full justify-start items-start  gap-2">
          <label htmlFor="gender" className="text-sm">
            Select your gender
          </label>
          <select
            onChange={handleChange}
            value={surveyData.gender}
            name="gender"
            id="gender"
            required
            className="w-full rounded border-[#E6E6E6] invalid:text-[#848484] "
          >
            <option value="" selected hidden disabled>
              Select your gender
            </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        {/* Age group */}
        <div className="flex flex-col w-full justify-start items-start  gap-2">
          <label htmlFor="ageGroup" className="text-sm">
            Select your age group
          </label>
          <select
            onChange={handleChange}
            value={surveyData.ageGroup}
            name="ageGroup"
            id="ageGroup"
            required
            className="w-full rounded border-[#E6E6E6] invalid:text-[#848484]"
          >
            <option value="" selected hidden disabled>
              Select age group
            </option>
            {ageGroup.map((age, index) => (
              <option key={index} value={age}>
                {age}
              </option>
            ))}
            {/* <option value="Male">Male</option>
            <option value="Female">Female</option> */}
          </select>
        </div>
        {/* Region */}
        <div className="flex flex-col w-full justify-start items-start  gap-2">
          <label htmlFor="region" className="text-sm">
            Select your region
          </label>
          <select
            onChange={handleChange}
            value={surveyData.region}
            name="region"
            id="region"
            required
            className="w-full rounded border-[#E6E6E6] invalid:text-[#848484]"
          >
            <option value="" selected hidden disabled>
              Select region
            </option>

            {regions.map((region, index) => (
              <option key={index} value={region}>
                {region}
              </option>
            ))}
            {/* <option value="Male">Male</option>
            <option value="Female">Female</option> */}
          </select>
        </div>
        <div className="flex flex-col w-full justify-start items-start  gap-2">
          <p htmlFor="flavor" className="text-sm">
            What flavour(s) did you buy?
          </p>
          <div>
            {flavors.map((flavor, index) => (
              <div key={index} className="flex items-center gap-2">
                <input
                  value={flavor.name}
                  type="checkbox"
                  checked={flavor.isChecked}
                  id={flavor.name}
                  onChange={(e) => {
                    setFlavors(
                      flavors.map((flvr, i) => {
                        if (i === index) {
                          flvr.isChecked = !flvr.isChecked;
                        }
                        return flvr;
                      })
                    );

                    let flvrs = [];
                    if (flavor.isChecked) {
                      flvrs.push(flavor.name);

                      setSurveyData({
                        ...surveyData,
                        flavours: [...surveyData.flavours, flavor.name],
                      });
                    }
                    // else remove from sizes
                    else {
                      flvrs = surveyData.flavours.filter(
                        (size) => size !== e.target.value
                      );

                      setSurveyData({
                        ...surveyData,
                        flavours: flvrs,
                      });
                    }
                  }}
                />
                <label htmlFor={flavor.name}>{flavor.name}</label>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col w-full justify-start items-start  gap-2">
          <p htmlFor="flavor" className="text-sm">
            What size(s) did you buy?
          </p>
          <div>
            {sku.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <input
                  value={item.name}
                  type="checkbox"
                  checked={item.isChecked}
                  // }
                  id={item.name}
                  onChange={(e) => {
                    setSku(
                      sku.map((item, i) => {
                        if (i === index) {
                          item.isChecked = !item.isChecked;
                        }
                        return item;
                      })
                    );

                    let sizes = [];
                    if (item.isChecked) {
                      sizes.push(item.name);

                      setSurveyData({
                        ...surveyData,
                        skus: [...surveyData.skus, item.name],
                      });
                    }
                    // else remove from sizes
                    else {
                      sizes = surveyData.skus.filter(
                        (size) => size !== e.target.value
                      );

                      setSurveyData({
                        ...surveyData,
                        skus: sizes,
                      });
                    }
                  }}
                />
                <label htmlFor={item.name}>{item.name}</label>
              </div>
            ))}
          </div>
        </div>

        {/* submit */}
        <div className="w-full mt-10">
          <button
            disabled={
              loading ||
              !surveyData.ageGroup ||
              !surveyData.region ||
              surveyData.flavours.length < 1 ||
              surveyData.skus.length < 1 ||
              !surveyData.gender
            }
            onClick={handleSubmit}
            className="w-full disabled:bg-[#ccc] text-white bg-[#2B86FF] transition  hover:bg-[#1f65bf] py-3 rounded"
          >
            Submit
          </button>
        </div>
      </form>
      <div className="flex w-full items-start justify-start flex-col">
        <img src={Bike} alt="" />
      </div>

      <ModalComponent
        showModal={openModal}
        handleClose={handleClose}
        setShowModal={setOpenModal}
      >
        <div className="flex flex-col gap-5 px-12 py-12">
          <h4 className="text-[#194179] text-lg text-center font-[600]">
            Awesome! <br /> Your submission has been recorded.
          </h4>

          <div className="mt-3">
            <p className="text-[#040505] text-sm text-center">
              Share this excitement with your friends and family.
            </p>
          </div>

          <div className="flex items-center justify-center gap-9 mb-2">
            <TwitterShareButton url="https://www.youtube.com/watch?v=d_lJHVaBHtA">
              <img
                src={TWITTER}
                alt=""
                onClick={() => handleShareCount("TWITTER")}
              />
            </TwitterShareButton>
            <WhatsappShareButton url="https://www.youtube.com/watch?v=d_lJHVaBHtA">
              <img
                src={WHATSAPP}
                alt=""
                onClick={() => handleShareCount("WHATSAPP")}
              />
            </WhatsappShareButton>
            <FacebookShareButton url="https://www.youtube.com/watch?v=d_lJHVaBHtA">
              <img
                src={FACEBOOK}
                alt=""
                onClick={() => handleShareCount("FACEBOOK")}
              />
            </FacebookShareButton>
          </div>
        </div>
      </ModalComponent>
    </div>
  );
};

export default Survey;
